
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_15wpl_99",
  "input": "awsui_input_2rhyz_15wpl_103",
  "input-readonly": "awsui_input-readonly_2rhyz_15wpl_153",
  "input-invalid": "awsui_input-invalid_2rhyz_15wpl_220",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_15wpl_231",
  "input-type-search": "awsui_input-type-search_2rhyz_15wpl_236",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_15wpl_252",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_15wpl_255",
  "input-container": "awsui_input-container_2rhyz_15wpl_262",
  "input-icon-left": "awsui_input-icon-left_2rhyz_15wpl_267",
  "input-icon-right": "awsui_input-icon-right_2rhyz_15wpl_274",
  "input-button-right": "awsui_input-button-right_2rhyz_15wpl_280"
};
  